import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from 'styles/theme';

const shouldForwardProp = (prop: string) => !prop.startsWith('$');

export const MODAL_EMAIL_CLASS = 'second-copy-modal-email';

export const emailModalTitleColor = '#000000';
export const emailModalActionColor = '#0b29fb';

export const EmailModalTitle = styled.span`
  line-height: 1.25;
  color: ${emailModalTitleColor};

  > span {
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    > span {
      display: block;
    }
  }

  @media (min-width: 769px) {
    > span::before {
      content: ' ';
    }
  }
`;

export const Description = styled.p`
  margin: 0 0 16px;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.primaryText};

  strong {
    font-weight: 700;
  }
`;

export const FormatSection = styled.div`
  margin-top: 16px;
`;

export const Summary = styled('div', { shouldForwardProp })<{
  $emailMode?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f2f2f2;

  @media (max-width: 768px) {
    ${({ $emailMode }) =>
      $emailMode &&
      css`
        margin-top: 12px;
        margin-bottom: 0;
      `}
  }
`;

export const SummaryLeft = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: ${emailModalActionColor};

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }

  strong {
    font-weight: 700;
  }
`;

export const SummaryAmount = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: ${emailModalActionColor};
  white-space: nowrap;
`;

export const FooterActions = styled('div', { shouldForwardProp })<{
  $emailMode?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;

  ${({ $emailMode }) =>
    $emailMode &&
    css`
      @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
      }

      @media (min-width: 769px) {
        flex-direction: row;

        button:first-of-type {
          order: 2;
        }

        button:last-of-type {
          order: 1;
        }
      }
    `}
`;

export const FooterButton = styled('button', { shouldForwardProp })<{
  $variant: 'outline' | 'solid';
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 108px;
  height: 40px;
  padding: 0 20px;
  border-radius: 999px;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }

  ${({ $variant }) =>
    $variant === 'solid'
      ? css`
          border: none;
          background: ${emailModalActionColor};
          color: #fff;
        `
      : css`
          border: 1px solid ${emailModalActionColor};
          background: #fff;
          color: ${emailModalActionColor};
        `}

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const secondCopyEmailModalGlobalStyles = css`
  .${MODAL_EMAIL_CLASS} [role='dialog'] h2,
  .${MODAL_EMAIL_CLASS} [role='dialog'] h2 * {
    color: ${emailModalTitleColor} !important;
  }
`;
